// StoreMenuDesktop.js
import React, { useState } from 'react';
import SectionList from '../shared/SectionList';
import bookIcon from 'assets/images/info/storeMenuIcons/book.png';
import coffeeIcon from 'assets/images/info/storeMenuIcons/coffee.png';
import consoleIcon from 'assets/images/info/storeMenuIcons/console.png';
import earphoneIcon from 'assets/images/info/storeMenuIcons/earphone.png';
import furnitureIcon from 'assets/images/info/storeMenuIcons/furniture.png';
import handshakenDrinkIcon from 'assets/images/info/storeMenuIcons/handshaken_drink.png';
import hotelIcon from 'assets/images/info/storeMenuIcons/hotel.png';
import parkIcon from 'assets/images/info/storeMenuIcons/park.png';
import petFoodIcon from 'assets/images/info/storeMenuIcons/pet_food.png';
import watchIcon from 'assets/images/info/storeMenuIcons/watch.png';

const icons = [
  { id: 1, title: "精選書籍", image: bookIcon },
  { id: 2, title: "咖啡", image: coffeeIcon },
  { id: 3, title: "主機遊戲", image: consoleIcon },
  { id: 4, title: "耳機", image: earphoneIcon },
  { id: 5, title: "家具", image: furnitureIcon },
  { id: 6, title: "手搖飲", image: handshakenDrinkIcon },
  { id: 7, title: "飯店", image: hotelIcon },
  { id: 8, title: "公園綠地", image: parkIcon },
  { id: 9, title: "寵物食品", image: petFoodIcon },
  { id: 10, title: "手錶", image: watchIcon },
];

const StoreMenuDesktop = ({
  storeMenu,
  menuContent,
  filteredMenuContent,
  searchQuery,
  imageMap,
  navigateToUrl
}) => {
  const [activeIconIndex, setActiveIconIndex] = useState(0);

  const sections = (searchQuery ? filteredMenuContent : storeMenu) || [];
  return (
    <div>
      {/* Category icons */}
      <div style={{ padding: "30px 40px 20px 40px", background: "#ffffff" }}>
        <div style={{
          display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
          gap: 20, maxWidth: 1200, margin: "0 auto"
        }}>
          {icons.map((icon, index) => (
            <div
              key={icon.id}
              onClick={() => setActiveIconIndex(index)}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                padding: '20px 15px', borderRadius: 12, cursor: 'pointer',
                transition: 'all .2s',
                border: activeIconIndex === index ? '2px solid #007bff' : '2px solid transparent',
                backgroundColor: activeIconIndex === index ? '#f0f8ff' : '#f8f9fa',
                transform: activeIconIndex === index ? 'scale(1.05)' : 'scale(1)'
              }}
            >
              <img src={icon.image} alt={icon.title} style={{ width: 48, height: 48, marginBottom: 12 }} />
              <span style={{
                fontSize: 14, fontWeight: activeIconIndex === index ? 600 : 500,
                color: activeIconIndex === index ? '#007bff' : '#495057', textAlign: 'center', lineHeight: 1.2
              }}>
                {icon.title}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Sections */}
      {sections.map((column, idx) => {
        const resolved = (searchQuery ? filteredMenuContent : menuContent)?.find(c => c.label === column.label);
        return (
          <SectionList
            key={`${column.label}-${idx}`}
            column={column}
            resolved={resolved}
            imageMap={imageMap}
            mode="desktop"
            navigateToUrl={navigateToUrl}
          />
        );
      })}

      {/* No results (desktop) handled in parent with ResultsCount and skip rendering when count=0 */}
    </div>
  );
};

export default StoreMenuDesktop;
